import React from 'react'
import { Control, Controller, FieldErrors } from 'react-hook-form'

import { Label, StyledInputField, StyledTextareaField } from './form.style'

interface FormFieldProps {
    name: string
    control: Control<any>
    errors?: FieldErrors<any>
    label?: string
    placeholder?: string
    rules?: Record<string, any>
    defaultValue?: string | number
    readOnly?: boolean
    textarea?: boolean
    min?: number
    max?: number
    step?: number
    type?: 'text' | 'number' | 'date' | 'datetime-local'
    onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
    className?: string
    children?: React.ReactNode
}

export const FormField: React.FC<FormFieldProps> = ({
    name,
    control,
    errors,
    label,
    placeholder = '',
    rules = {},
    defaultValue = '',
    readOnly = false,
    textarea = false,
    min,
    max,
    step,
    type = 'text',
    onChange,
    className = 'p-field',
}) => {
    const errorMessage = getErrorMessage(errors && errors[name])
    console.log(rules.required)
    const isRequired = rules?.required !== null && rules?.required !== undefined

    return (
        <div className={className}>
            {label && (
                <Label htmlFor={name}>
                    {label}
                    {isRequired && <span style={{ color: '#D32F2F', marginLeft: 4 }}>*</span>}
                </Label>
            )}
            <Controller
                name={name}
                control={control}
                defaultValue={defaultValue}
                rules={rules}
                render={({ field }) =>
                    textarea ? (
                        <StyledTextareaField
                            id={name}
                            {...field}
                            className={errorMessage ? 'p-invalid' : ''}
                            placeholder={placeholder}
                            readOnly={readOnly}
                            autoResize
                            value={field.value || ''}
                            onChange={(e) => field.onChange(e.target.value)}
                        />
                    ) : (
                        <StyledInputField
                            id={name}
                            {...field}
                            className={errorMessage ? 'p-invalid' : ''}
                            placeholder={placeholder}
                            readOnly={readOnly}
                            type={type}
                            min={min}
                            max={max}
                            step={step}
                            value={field.value || ''}
                            onChange={onChange ? (e) => onChange(e) : (e) => field.onChange(e.target.value)}
                        />
                    )
                }
            />
            {errorMessage && <small className="p-error">{errorMessage}</small>}
        </div>
    )
}

function getErrorMessage(error: any): string | undefined {
    if (error?.message) {
        return error.message
    }
    if (typeof error === 'string') {
        return error
    }
    return undefined
}
